import React from 'react';

function contextHookCreator<S>(
  context: React.Context<S>,
  hookName: string,
  providerName: string,
): () => S {
  return () => {
    const ctx = React.useContext<S>(context);
    if (!ctx || ctx === undefined || ctx === null) {
      throw new Error(`${hookName} must be within ${providerName}`);
    }

    return ctx;
  };
}

export default contextHookCreator;
